// extracted by mini-css-extract-plugin
module.exports = {"header":"StepHeader_header__O91Gp","icon":"StepHeader_icon__13fME","title":"StepHeader_title__1fJ3c"};